// @flow

export { default as Avatar } from './Avatar';
export type { AvatarProps, AvatarPhoto, Size } from './Avatar';
